import moment from 'moment';
import Pikaday from 'pikaday';

import { showProgram } from './slides.js';

export default (minDate, maxDate, excludeRange) => {
	return new Pikaday({
		field: document.querySelector('#calendar__input'),
		container: document.querySelector('#calendar__widget'),
		firstDay: 1,
		minDate,
		maxDate,
		bound: false,
		enableSelectionDaysInNextAndPreviousMonths: true,
		i18n: {
			previousMonth: 'Предыдущий месяц',
			nextMonth: 'Следующий месяц',
			months: [
				'Январь',
				'Февраль',
				'Март',
				'Апрель',
				'Май',
				'Июнь',
				'Июль',
				'Август',
				'Сентябрь',
				'Октябрь',
				'Ноябрь',
				'Декабрь',
			],
			weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
			weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
		},
		onSelect: (date) => {
			const currentDate = moment(date).format('YYYY-MM-DD')
			showProgram(currentDate)

			document.querySelectorAll('.carousel--schedule .schedule-date').forEach((date) => {
				date.classList.remove('schedule-date--active')
				if (date.getAttribute('data-date') === currentDate) {
					date.classList.add('schedule-date--active')
				}
			})
			const findSlider = document.querySelector('.carousel--schedule .carousel-container').swiper
			const items = Array.from(document.querySelectorAll('.carousel--schedule .carousel-item'))
			const findIndex = items.findIndex((item) =>
				item.querySelector('.schedule-date').classList.contains('schedule-date--active')
			)
			findSlider.slideTo(findIndex, 300)
		},
		disableDayFn: function (dateTime) {
			const currentDate = moment(dateTime).format('YYYY-MM-DD')
			return !excludeRange?.[currentDate]
		},
	})
}
